import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { useAccount } from 'shared/hooks/use-web3';
import { networkHandler } from 'shared/utils/networkHandler';

import guys1 from 'assets/animation/guys/guys1-min.png?format=webp;avif&as=picture';
import guys2 from 'assets/animation/guys/guys2-min.png?format=webp;avif&as=picture';
import LinkSvg from 'assets/link.svg?react';

const guys = [guys2, guys1];

interface Props {
  messages?: string[];
  className?: string;
  hash?: `0x${string}` | null;
  selector?: string;
}

const GuysLoader = ({ messages, className, hash, selector }: Props) => {
  const { chainId } = useAccount();
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);
  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    if (messages && messages.length > 0) {
      interval = setInterval(() => {
        setCurrentMessage((prevMessage) => (prevMessage + 1) % messages.length);
      }, 10000);
    }
    return () => clearInterval(interval);
  }, [messages]);
  useEffect(() => {
    let interval: ReturnType<typeof setInterval>;
    let timeout: ReturnType<typeof setTimeout>;

    const startAnimation = () => {
      setIsAnimating(true);
      interval = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % guys.length);
      }, 200);
      timeout = setTimeout(() => {
        clearInterval(interval);
        setIsAnimating(false);
      }, 1200);
    };

    if (isAnimating) {
      startAnimation();
    } else {
      timeout = setTimeout(() => {
        startAnimation();
      }, 2000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isAnimating]);

  const content = (
    <div
      className={`flex w-[400px] flex-col items-center justify-center ${
        className ? className : ''
      }`}
    >
      <div className="flex w-[400px] flex-col items-center justify-center">
        <div className={`animation-container`}>
          <OptimizedImage
            imageData={guys[index]}
            alt="Animated character"
            className="animated-image guys-delay h-[9.8125rem] w-[9.375rem]"
          />
        </div>
        {messages && messages.length >= 0 && (
          <div className="top-[200px] flex flex-col items-center">
            <div className="h-[2px] w-full bg-loader-border" />
            <div className="flex w-[90%] flex-col text-wrap bg-loader-content px-[30px] py-[16px] text-center">
              {hash && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center text-[12px] text-white sm:text-[16px]"
                  href={`${networkHandler(chainId!)}/${hash}`}
                >
                  <LinkSvg className="mr-[10px] h-[18px] w-[16px] text-white sm:h-[22px] sm:w-[22px]" />{' '}
                  {t('common.transaction')}...
                  {hash!.slice(-4)}
                </a>
              )}
              <span className="text-[12px] text-white sm:text-[16px]">
                {t(messages[currentMessage])}
              </span>
            </div>
            <div className="h-[2px] w-full bg-loader-border" />
          </div>
        )}
      </div>
    </div>
  );
  if (selector) {
    const portalRoot = document.querySelector(selector);
    if (portalRoot) {
      return ReactDOM.createPortal(content, portalRoot);
    }
  }

  return content;
};

export default GuysLoader;
